import QuillResizeImage from 'quill-resize-image';
import { Quill } from "react-quill";

export const FontAttributor = Quill.import('attributors/style/font');
FontAttributor.whitelist = [
  'Sans Serif',
  'Arial',
  'Courier New',
  'Georgia',
  'Lucida Sans',
  'Tahoma',
  'Times New Roman',
  'Trebuchet MS',
  'Verdana',
];

Quill.register(FontAttributor, true)
Quill.register('modules/imageResize', QuillResizeImage);
